export const crossFadeImages = [
    "/assets/Property 1=Frame 27.png",
    "/assets/Property 1=Frame 28.png",
    "/assets/Property 1=Frame 29.png",
    "/assets/Property 1=Frame 30.png",
    "/assets/Property 1=Frame 31.png",
    "/assets/Property 1=Frame 32.png",
    "/assets/Property 1=Frame 33.png",
    "/assets/Property 1=Frame 34.png",
    "/assets/Property 1=Frame 35.png",
]